import { atom } from 'recoil';

export const isTruckDriversModalOpenAtom = atom<boolean>({
  key: 'isTruckDriversModalOpenAtom',
  default: false,
});
